import { ReactNode } from 'react';

import { SimpleTooltip } from '@/components/ui/simple-tooltip';

interface ApprovedValueLabelProps {
  children: ReactNode;
  /** Explains which downstream document this value feeds — the labels alone are too terse. */
  tooltip: ReactNode;
}

/**
 * The `Inv` / `Bill` micro-label that tells the two stacked values in the Approved column apart.
 *
 * Fixed width so both rows align into a column, and intentionally tiny: the split must not make
 * the table taller than it has to be. Because `INV`/`BILL` on their own don't say what they
 * affect, each carries a tooltip naming the document (and whether it is income or expense).
 */
export const ApprovedValueLabel = ({ children, tooltip }: ApprovedValueLabelProps) => (
  <SimpleTooltip content={tooltip}>
    <span className="w-7 shrink-0 cursor-help text-[10px] uppercase leading-tight tracking-wide text-muted-foreground">
      {children}
    </span>
  </SimpleTooltip>
);
